import moment from 'moment';
import {
    EBFL1RecordCode,
    EBFL1RecordState,
    TBFL1CommonData,
    TBFL1CommonFields,
} from '../@types';
import { EMARPOLDocuments } from '../../marpol/@types';

export type TBFL1ItemB1 =
    | {
          place: 'PORT';
          portName: string;
      }
    | {
          place: 'AT_SEA';
          position: {
              latitude: string;
              longitude: string;
          };
      };
export type TBFL1ItemB2 = {
    remarks: string;
};
export type TBFL1ItemB3 = {
    remarks: string;
};
export type TBFL1ItemB4 = {
    remarks: string;
};
export type TBFL1ItemB5 = {
    remarks: string;
};
export type TBFL1ItemB6 = {
    remarks: string;
};

export type TBFL1B1 = TBFL1CommonFields &
    TBFL1CommonData & {
        recordCode: EBFL1RecordCode.BFL1B1;
        item1: TBFL1ItemB1;
        item2: TBFL1ItemB2;
        item3: TBFL1ItemB3;
        item4: TBFL1ItemB4;
        item5: TBFL1ItemB5;
        item6: TBFL1ItemB6;
    };

export type TBFL1GroupA = TBFL1B1;

const BFL1_GROUPB_DEFAULTS: {
    B1: TBFL1B1;
} = {
    B1: {
        id: '',
        _rev: '',
        marpolType: EMARPOLDocuments.BFL1,
        state: EBFL1RecordState.IDLE,
        selectedDate: moment().format('YYYY-MM-DD'),
        remarks: '',
        item1: {
            place: 'AT_SEA',
            position: {
                latitude: '',
                longitude: '',
            },
        },
        item2: {
            remarks: '',
        },
        item3: {
            remarks: '',
        },
        item4: {
            remarks: '',
        },
        item5: {
            remarks: '',
        },
        item6: {
            remarks: '',
        },
        recordCode: EBFL1RecordCode.BFL1B1,
        processedTanks: [],
    },
};

export { BFL1_GROUPB_DEFAULTS };
